// extracted by mini-css-extract-plugin
module.exports = {"boxDropdown":"_3Hx2XxkmbPt7R8bmWd7VUL","content":"_2WIUAkEILLOCJOYUjoKiwY","bgBlock":"_1cxQAgKmiKfFuC2NtPb7vp"};